// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion_bOPqi {
    cursor: pointer;
    min-height: 75px;
}

.suggestion_bOPqi[data-disabled="true"] {
    cursor: not-allowed;
}

.header_zPeWy {
    box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
    z-index: 1;
    /* padding-bottom: 0; */
}

.list_BmTkN {
    flex: 1 1 400px !important;
    background: white;
    padding: var( --size-padLarge );
}

.resultCount_kl1oX {
    padding: var( --size-padLarge ) 0 0 0;
}

.close_EcyyV {
    position: absolute;
    z-index: 1;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/DeviceSearch.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;IAC9C,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B","sourcesContent":[".suggestion {\n    cursor: pointer;\n    min-height: 75px;\n}\n\n.suggestion[data-disabled=\"true\"] {\n    cursor: not-allowed;\n}\n\n.header {\n    box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n    z-index: 1;\n    /* padding-bottom: 0; */\n}\n\n.list {\n    flex: 1 1 400px !important;\n    background: white;\n    padding: var( --size-padLarge );\n}\n\n.resultCount {\n    padding: var( --size-padLarge ) 0 0 0;\n}\n\n.close {\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestion": `suggestion_bOPqi`,
	"header": `header_zPeWy`,
	"list": `list_BmTkN`,
	"resultCount": `resultCount_kl1oX`,
	"close": `close_EcyyV`
};
export default ___CSS_LOADER_EXPORT___;
